import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLanguage } from "../../../context/LanguageContext";

// Import your background + icons
import bgImage from "../../../images/bg/feature-bg.jpg";
import icon01 from "../../../images/icon/fea-small-icon01.svg";
import icon04 from "../../../images/icon/fea-small-icon04.svg";
import icon02 from "../../../images/icon/fea-small-icon02.svg";
import icon06 from "../../../images/icon/fea-small-icon06.svg";

// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

const featureIcons = [icon01, icon04, icon02, icon06];

const FeatureSection: React.FC = () => {
  const { t } = useLanguage();
  const sectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    // Reset background
    gsap.set(el, {
      backgroundPosition: "center 0px",
      backgroundSize: "cover",
    });

    // GSAP Parallax Effect
    gsap.to(el, {
      backgroundPositionY: "200px",
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top bottom",
        end: "bottom top",
        scrub: 1,
      },
    });
  }, []);

  return (
    <section
      ref={sectionRef}
      className="feature-section parallax-section"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="xb-feature-content">
              <div className="sec-title sec-title-center fea-sec-title mb-35">
                <span className="sub-title mb-20">{t.about.whyUsSub}</span>
                <h2 className="title title-line_height">
                  {t.about.whyUsTitle}
                </h2>
              </div>

              <div className="row mt-none-30">
                {t.about.whyUs.map((item, idx) => (
                  <div className="col-lg-6 col-md-6 mt-30" key={idx}>
                    <div className={`xb-feature-item xb-feature-item2 ${idx % 2 === 1 ? "xb-border" : ""}`}>
                      <div className="xb-item--inner xb-border">
                        <span className="xb-item--icon">
                          <img src={featureIcons[idx] || icon01} alt="icon" />
                        </span>
                        <h2 className="xb-item--title" style={{ fontSize: "1.2rem", lineHeight: "1.4" }}>
                          {item.title}
                        </h2>
                        <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "13px", marginTop: "8px", lineHeight: "1.6" }}>
                          {item.desc}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
